var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_vm._l((_vm.data.areas),function(area,i){return [_c('MapArea',{key:i,attrs:{"data":area}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }